import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Newspaper, Hash } from "@phosphor-icons/react";

const TAG_COLORS = {
    NICHE: "text-electric-blue border-electric-blue/40 bg-electric-blue/5",
    AUDIO: "text-purple-300 border-purple-400/40 bg-purple-500/5",
    ALGO: "text-yellow-300 border-yellow-400/40 bg-yellow-500/5",
    RPM: "text-emerald-300 border-emerald-400/40 bg-emerald-500/5",
    HOOK: "text-pink-300 border-pink-400/40 bg-pink-500/5",
};

export default function AlphaFeed() {
    const [posts, setPosts] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        api.get("/alpha-feed")
            .then((r) => setPosts(r.data))
            .finally(() => setLoading(false));
    }, []);

    return (
        <section data-testid="alpha-feed-section" className="bg-[#0A0A0A] border border-white/10 relative overflow-hidden">
            <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-electric-blue to-transparent" />
            <div className="px-6 py-4 border-b border-white/10 flex items-center justify-between">
                <div className="flex items-center gap-3">
                    <Newspaper size={20} className="text-electric-blue" weight="duotone" />
                    <div>
                        <p className="label-mono text-electric-blue">WEEKLY ALPHA</p>
                        <h2 className="font-heading font-bold text-lg">The Trend Spotter</h2>
                    </div>
                </div>
                <span className="hidden md:inline label-mono text-[10px]">DELIVERED MONDAYS // 09:00 UTC</span>
            </div>

            <div className="divide-y divide-white/5">
                {loading && (
                    <div className="p-6 label-mono text-muted-foreground animate-pulse">LOADING SIGNAL...</div>
                )}
                {!loading && posts.length === 0 && (
                    <div className="p-6 label-mono text-muted-foreground">SIGNAL FEED EMPTY</div>
                )}
                {posts.map((p, i) => (
                    <div
                        key={p.id}
                        data-testid={`alpha-post-${i}`}
                        className="px-6 py-4 flex items-start gap-4 hover:bg-electric-blue/5 transition-colors group"
                    >
                        <div className={`shrink-0 inline-flex items-center gap-1 px-2 py-1 border text-[10px] label-mono ${TAG_COLORS[p.tag] || "text-muted-foreground border-white/10"}`}>
                            <Hash size={10} weight="bold" />
                            {p.tag}
                        </div>
                        <div className="flex-1 min-w-0">
                            <p className="font-semibold text-white group-hover:text-electric-blue transition-colors">
                                {p.title}
                            </p>
                            <p className="text-sm text-muted-foreground mt-1">{p.body}</p>
                        </div>
                    </div>
                ))}
            </div>
        </section>
    );
}
